import { motion } from "framer-motion";
import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { client } from "../../client";
import { images } from "../../constants";
import { AppWrapper } from "../../wrapper";
import "./Footer.scss";
const Footer = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const name = useRef();
  const email = useRef();
  const message = useRef();

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: "contact",
      name: name.current.value,
      email: email.current.value,
      message: message.current.value,
    };

    client
      .create(contact)
      .then(() => {
        setLoading(false);
        history.push("/");
      })
      .catch((err) => console.log(err));
    setSubmitted(true);
  };
  return (
    <>
      <h2 className="head-text">Take a coffee & chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:ramitsarkar902@gmail.com" className="p-text">
            ramitsarkar902@gmail.com
          </a>
        </div>
        {/* <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+91 9434973413/9547964757" className="p-text">
            +91 9434973413/9547964757
          </a>
        </div> */}
      </div>
      {!submitted ? (
        <form className="app__footer-form app__flex" onSubmit={handleSubmit}>
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              ref={name}
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              ref={email}
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              ref={message}
            />
          </div>
          <button type="submit" className="p-text">
            {!loading ? "Send Message" : "Sending..."}
          </button>
        </form>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch!</h3>
          <motion.div
            animate={{
              y: [300, 0],
              opacity: [0, 0.2, 0.8, 1],
            }}
            transition={{
              type: "tween",
              duration: 2,
              delayChildren: 0.5,
            }}
            whileHover={{ scale: [1, 1.05] }}
            className="footer__qr-div"
          >
            <div>
              <p>Scan the QR code to claim rewards!</p>
              <img
                src="https://i.pinimg.com/originals/c1/1d/05/c11d05415f5ff082abf5155fa6d98e1f.gif"
                alt=""
              />
            </div>

            <img className="footer__qr-img" src={images.qr} alt="" />
          </motion.div>
        </div>
      )}
    </>
  );
};

export default AppWrapper(Footer, "contact");
